import * as React from 'react';

import { getTranslation } from '@base/utils';

import { AppDialog } from '@components';

import { IStreamPostDialogProps } from './types';

import * as s from './StreamPostDialog.scss';

const TEXT_MAX_LENGTH = 140;

export function StreamPostDialog(props: IStreamPostDialogProps) {
	const {
		appName,
		title,
		description,
		imageUrl,
		onClose,
		onPublish,
	} = props;
	const [text, setText] = React.useState('');

	const t = getTranslation('components.AppMainPage.StreamPostDialog');

	const textChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) =>
		setText(e.target.value);

	const publishHandler = () => onPublish(text);

	return <AppDialog
		title={t('postToFeed')}
		visible={true}
		onClose={onClose}
	>
		<div className={s.dialog}>
			<div className={s.heading}>
				{t('appOffers', { appName })}
			</div>
			{imageUrl && <img className={s.image} src={decodeURIComponent(imageUrl)} />}
			<h3 className={s.title}>{title}</h3>
			<div className={s.description}>{description}</div>
			<textarea
				className={s.text}
				maxLength={TEXT_MAX_LENGTH}
				placeholder={t('maxSymbolsLength', { maxLength: TEXT_MAX_LENGTH })}
				onChange={textChangeHandler}
				defaultValue={text}
			/>
			<button
				className={s.publishButton}
				onClick={publishHandler}
				disabled={!text}
			>
				{t('publish')}
			</button>
		</div>
	</AppDialog>;
}
